import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "lexicon-card" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "entry" }
const _hoisted_4 = { class: "head" }
const _hoisted_5 = {
  key: 0,
  class: "translit"
}
const _hoisted_6 = {
  key: 1,
  class: "pos"
}
const _hoisted_7 = {
  key: 2,
  class: "gloss"
}
const _hoisted_8 = { class: "body" }
const _hoisted_9 = {
  key: 0,
  class: "label"
}
const _hoisted_10 = {
  key: 0,
  class: "definition"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "font-hebrew"
}
const _hoisted_13 = {
  key: 3,
  class: "font-greek"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 6 }
const _hoisted_17 = { class: "attribution" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.card.title), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.card.entry), 1)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("span", {
        class: _normalizeClass(["headword", _ctx.scriptClass])
      }, _toDisplayString(_ctx.card.headword), 3),
      (_ctx.card.translit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.card.translit), 1))
        : _createCommentVNode("", true),
      (_ctx.card.pos)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.card.pos), 1))
        : _createCommentVNode("", true),
      (_ctx.card.gloss)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.card.gloss), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.body, (p, i) => {
        return (_openBlock(), _createElementBlock("p", {
          key: i,
          class: "paragraph",
          style: _normalizeStyle({ paddingLeft: `${p.depth * 1.1}rem` })
        }, [
          (p.label)
            ? (_openBlock(), _createElementBlock("b", _hoisted_9, _toDisplayString(p.label), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.runs, (r, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (r.kind === 'definition')
                ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(r.text), 1))
                : (r.kind === 'emphasis' || r.kind === 'foreign')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_11, _toDisplayString(r.text), 1))
                  : (r.kind === 'hebrew')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(r.text), 1))
                    : (r.kind === 'greek')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(r.text), 1))
                      : (r.kind === 'reference')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 4,
                            class: "reference",
                            title: r.verse ? _ctx.verseRef(r.verse) : undefined
                          }, _toDisplayString(r.text), 9, _hoisted_14))
                        : (r.kind === 'cross_reference' && _ctx.isStrongs(r.entry))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 5,
                              class: "cross",
                              onClick: ($event: any) => (_ctx.$emit('open-strongs', r.entry))
                            }, _toDisplayString(r.text), 9, _hoisted_15))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(r.text), 1))
            ], 64))
          }), 128))
        ], 4))
      }), 128))
    ]),
    _createElementVNode("footer", _hoisted_17, _toDisplayString(_ctx.card.attribution), 1)
  ]))
}